module.exports = __webpack_public_path__ + "static/media/submit-request.abf2b2ba.svg";